type BrowserId {
  expected_cookie: Boolean
}
